import {constants} from './../app-constants';
import {PaginacaoParamModel} from './../model/paginacao-param.model';
import {Component, OnInit} from '@angular/core';
import {OrdemServicoService} from '../service/ordem-servico.service';
import {ClienteModel, EnderecoModel} from '../model';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {BuscarAmbienteIn} from '../model/buscar-ambiente-in.model';
import {AmbienteModel} from '../model/ambiente.model';

@Component({
  selector: 'app-criar-osambiente',
  templateUrl: './criar-osambiente.component.html',
  styleUrls: ['./criar-osambiente.component.css']
})
export class CriarOSAmbienteComponent implements OnInit {
  paginacao: PaginacaoParamModel = new PaginacaoParamModel();
  numberPage = 1;

  ambientes: Array<any> = [];

  ambientesSel: Array<AmbienteModel> = [];
  ambientesSelecionados: Array<AmbienteModel> = [];
  ativo: any;
  display: Boolean = true;
  endereco: EnderecoModel;
  buscarAmbienteIn: BuscarAmbienteIn = new BuscarAmbienteIn();
  clienteModel: ClienteModel = new ClienteModel();

  selecionarAmbiente($event) {
    this.ambientesSelecionados = $event;
    this.setAmbienteAtivo();
  }

  constructor(private loadingBar: NgxUiLoaderService, private ordemServicoService: OrdemServicoService) { }

  ngOnInit() {
    this.ambientesSelecionados = [];
    this.selecionarAmbiente(this.ambientesSelecionados);
    this.clienteModel = JSON.parse(localStorage.getItem(constants.clienteKey));
    this.ativo = JSON.parse(localStorage.getItem(constants.ativoKey));
    this.listarAmbientes();

  }

  public listarAmbientes() {
    this.loadingBar.start();
    this.endereco = JSON.parse(localStorage.getItem(constants.enderecoSelecionadoKey));
    this.buscarAmbienteIn.codigoEndereco = this.endereco.codigoEndereco;
    this.buscarAmbienteIn.codigoCliente = this.clienteModel.clienteContratoId.toString();
    this.ordemServicoService.listarAmbientes(this.buscarAmbienteIn)
      .subscribe(response => {
        this.numberPage++;
        this.onSuccess(response.ambientes);
      });
  }

  setAmbienteAtivo() {
    if (this.ativo !== null &&
      this.ativo !== undefined) {
      if (this.ativo.ambiente !== null) {
        this.ambientes.forEach(ambiente => {
          if (ambiente.descricao === this.ativo.ambiente && !this.ambientesSelecionados.includes(ambiente)) {
            this.ambientesSelecionados.push(ambiente);
          }
        });
      }
    }
    localStorage.setItem(constants.ambientes, JSON.stringify(this.ambientesSelecionados));
  }

  onSuccess(res) {
    this.loadingBar.stop();
    if (res) {
      res.forEach(ambiente => {
        this.ambientes.push(ambiente);
      });
    }
  }

}
